import type { AppStore } from './store';

/**
 * Keeps the open app on the latest published version without closing and reopening it.
 * Checks version.json when the app comes back to the screen and every few minutes. A new version is
 * loaded straight away when nothing is in progress (no form open, nothing uploading); otherwise as soon
 * as that finishes. Until then a bar offers "Update now".
 */
export function watchForUpdates(S: AppStore) {
  if (import.meta.env.DEV) return; // local development: Vite reloads by itself
  const check = async () => {
    if (S.updateReady || navigator.onLine === false) return;
    try {
      const r = await fetch(`./version.json?t=${Date.now()}`, { cache: 'no-store' });
      if (!r.ok) return;
      const { build } = await r.json() as { build?: string };
      if (build && build !== __BUILD__) { S.updateReady = true; S.notify(); applyWhenIdle(S); }
    } catch { /* offline or not published yet: try again later */ }
  };
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') void check(); });
  addEventListener('online', () => void check());
  setInterval(() => void check(), 5 * 60_000);
  void check();
}

/** Busy = a form is open or a change is still uploading; reloading then could lose what is being typed. */
export const busy = (S: AppStore) => !!S.overlay || S.uploading > 0 || S.engine.status === 'saving';

function applyWhenIdle(S: AppStore) {
  if (!busy(S)) return location.reload();
  const go = () => { if (!busy(S)) { off(); clearInterval(t); location.reload(); } };
  const off = S.subscribe(go);
  const t = setInterval(go, 5_000);
}
